import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IsNullOrEmpty } from '../../core/utility';
import { post } from '../../core/client';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { SentimentVeryDissatisfied, TaskAlt } from '@mui/icons-material';
import kocAilemlogo from '../../assets/images/koc-ailem-logo.png';
import ConfirmationModal from '../../components/confirmation-modal';
import PhoneInput from '../../components/inputs/phone';
import { Alert, Grid, TextField, TextFieldProps, Checkbox, FormControlLabel } from "@mui/material";
import { CustomButton } from "../../components/buttons";

const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

interface InputErrorModel {
    name: string;
    errorText: string;
}

const WhatsappUnsubscribe = () => {

    let query = useQuery();
    const encriptedText = query.get('subs');

    const [isSend, setIsSend] = useState<boolean>(false);
    const [sendLoading, setSendLoading] = useState<boolean>(false);
    const [isFailed, setIsFailed] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(true);
    const [phone, setPhone] = useState("");
    const [inputErrors, setInputErrors] = useState<Array<InputErrorModel>>([]);

    useEffect(() => {
        if (!IsNullOrEmpty(encriptedText)) {
            getSubs(encriptedText!);
            setShowConfirmationModal(true);
        }
    }, [encriptedText])

    const getSubs = async (encriptedText: string) => {
        setIsFailed(false);
        setIsSend(false);
        setSendLoading(true);
        const request = {
            subs: encriptedText
        }
        const { data, fail, errorMessage } = await post<any>('api/membership/get-whatsapp-subs', request);
        setSendLoading(false);
        if (data) {
            setPhone(data.phone);
        }
        if (fail) {
            setIsFailed(true);
        }
    }

    const sendUnsubscribe = async (encriptedText: string) => {
        if (!validate(phone)) {
            setShowConfirmationModal(true);
            return;
        }
        setIsFailed(false);
        setIsSend(false);
        setSendLoading(true);
        const request = {
            subs: encriptedText
        }
        const { data, fail, errorMessage } = await post<any>('api/membership/whatsapp-unsubscribe', request);
        setSendLoading(false);
        if (data) {
            setIsSend(true);
        }
        if (fail) {
            setIsFailed(true);
        }
    }

    const setError = (errorText = 'Zorunlu alan') => {
        var name = "phone";
        const error: InputErrorModel = { name, errorText };
        setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
    };

    const validate = (phone: string): boolean => {
        setInputErrors([]);
        let isValid = true;

        if (IsNullOrEmpty(phone) || phone[0] !== '9' || phone[1] !== '0' || phone.length !== 12) {
            setError('Geçersiz telefon');
            isValid = false;
        }

        return isValid;
    };


    const handleSave = async () => {
        setShowConfirmationModal(false);
        sendUnsubscribe(phone)
    }

    const handleChange = (e: any) => {
        setPhone(e.target.value);
    };

    return (
        <Container maxWidth="md" sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            {
                sendLoading ?
                    <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" paddingY={2}>
                        <p>Talebiniz iletiliyor...</p>
                        <CircularProgress />
                    </Box>
                    : isSend && (
                        <>
                        <Grid container xs={12} sx={{ justifyContent: "center" }}>
                            <Grid item paddingY={4} textAlign="center" className="success-container">
                                <TaskAlt className='success-icon' color='success' />
                                <p>Whatsapp iletişim listesinden çıkarılma talebiniz alınmıştır.</p>
                                <p>Whatsapp üzerinden tekrar iletişime geçilmesini isterseniz <strong>iletisim@kocailem.com.tr</strong> adresine eposta gönderebilirsiniz.</p>
                            </Grid>
                            <Grid item>
                            <img src={kocAilemlogo} alt='KoçAilem Logo' />
                            </Grid>
                        </Grid>
                        </>
                    )
            }
            {
                isFailed && (
                    <Box paddingY={4} textAlign="center" className="success-container">
                        <SentimentVeryDissatisfied className='success-icon' color='error' />
                        <p>Talep iletilirken bir sorun yaşandı. Lütfen, bir kaç dakika sonra tekrar deneyiniz.</p>
                        <p>Sorun devam ediyorsa <strong>iletisim@kocailem.com.tr</strong> adresi üzerinden iletişime geçebilirsiniz.</p>
                    </Box>
                )
            }

            {showConfirmationModal && !isFailed && (
                <Grid container rowSpacing={2} columnSpacing={0} sx={{
                    justifyContent: 'center', alignItems: 'center', width: '800px', border: "2px solid #19b3cb",
                    borderRadius: 3,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    p: 4,
                    backgroundColor: "background.paper"
                }}>
                    <Grid item>
                        <p>WhatsApp üzerinden KoçAilem'in en önemli ayrıcalıkları hakkında bilgi almak <b>İSTEMİYORUM.</b></p>
                    </Grid>
                    <Grid container item xs={12} columnSpacing={4} rowSpacing={2} sx={{ justifyContent: "center", alignItems: "flex-start" }}>
                    <Grid item sx={{ maxWidth: 300, flexGrow: 1 }}>
                        <PhoneInput
                            id="phone"
                            name="phone"
                            caption="Telefon Numarası"
                            placeholder="90 (5##) ### ## ##"
                            format="## (###) ### ## ##"
                            value={phone}
                            onChange={handleChange}
                            errorText={inputErrors.find(x => x.name === 'phone')?.errorText}
                        />
                    </Grid>
                    <Grid item>
                        <CustomButton
                            text="Gönder"
                            className="btn-primary"
                            disabled={sendLoading}
                            loading={sendLoading}
                            onClick={handleSave} />
                    </Grid>
                    </Grid>
                </Grid>
            )}

        </Container>
    )
}

export default WhatsappUnsubscribe